export default "__VITE_ASSET__CdwFQRqh__"